
import {
    WalletModalProvider,
    WalletDisconnectButton,
    WalletMultiButton
} from '@solana/wallet-adapter-react-ui';
import { useWallet } from '@solana/wallet-adapter-react';
import { FaCheckCircle } from "react-icons/fa";
import img from '../../assets/images/1.jpg'

import { motion } from 'motion/react';
import { blobAnimation } from '../../animations/animations';
import solLogo from '../../assets/images/solIcon.webp'
import { useSolPrice } from '../../hooks/useSolPrice';
import { Link } from 'react-router-dom';


const WalletButton = WalletMultiButton

export default function SubscriptionLayout({ children }) {

    const { select, publicKey, connected, disconnect, sendTransaction } = useWallet();
    // const { solPrice } = useSolPrice()
    return (


        <div className='relative overflow-hidden'>
            <motion.span {...blobAnimation.props} className="bg-blue-500 rounded-full h-[300px] w-[300px] blur-[180px] opacity-50 absolute bottom-[50%] left-0 z-[1]" />
            <motion.span {...blobAnimation.props} className="bg-orange-500 rounded-full h-[300px] w-[300px] blur-[180px] opacity-50 absolute bottom-[50%] right-0 z-[1]" />

            <img src={img} alt="" className="w-full blur-sm absolute top-[2] z-0 opacity-40" />
            <div className="container mx-auto py-5 min-h-[100vh]  h-full relative space-y-10 !z-20">
                <div className="flex justify-between  items-center  shadow-xs p-5 rounded    ">
                    <div className="flex flex-col gap-2 text-neutral-200">
                        <Link to={'/'} className='font-bold text-3xl font-logo tracking-widest text-yellow-500'>Phoenix</Link>
                        {<WalletButton />}
                    </div>
                    {/* <div className=' grid grid-cols-1 gap-2 w-max items-start'>
                        <div className='bg-green-800/20 flex gap-2 px-3 py-2 rounded-full items-center w-full animate-pulse'>
                            <FaCheckCircle className='text-green-500 text-2xl' />
                            <p className=''> Subscribed</p>
                            <div className='flex gap-2 items-center'>
                                <img src={solLogo} alt="" className="h-5" />
                                {solPrice && <p className='text-green-500 font-bold'>{solPrice} $ </p>}
                            </div>
                        </div>

                    </div> */}

                </div>
                <div className=" ">
                    <div className="flex flex-col gap-2 text-neutral-200">
                        <h1 className='heading-large  '>Start using Phoenix Bot Now !</h1>
                    </div>
                </div>
                <div className='flex w-full gap-5 z-10'>
                    {children}
                </div>
            </div>
        </div>

    )


}